module.exports = __webpack_public_path__ + "img/banner_en.e9c43505.png";